window.onload = () => {

  let teamCards = document.getElementsByClassName('team-card');

  if (teamCards) {
    [].forEach.call(teamCards, function(card) {
      card.addEventListener('click', function(ev) {
        let self = this;
        synopsisSwap(self);
      });
    });
  }

}

let synopsisSwap = (self) => {

  let isActive = self.getAttribute('active');

  let descriptionParent = self.firstElementChild.children[3].firstElementChild;
  let synopsisParent = self.firstElementChild.children[4].firstElementChild;
  let fullTextParent = self.firstElementChild.children[5].firstElementChild;

  let description = descriptionParent.firstChild;
  let synopsis = synopsisParent.firstChild;
  let fullText = fullTextParent.firstChild;

  let textValues = {
    synopsis: synopsis.nodeValue,
    fullText: fullText.nodeValue
  };

  if (!isActive) {
    self.setAttribute('active', 'true');
    description.nodeValue = textValues.fullText;
  } else {
    self.setAttribute('active', '');
    description.nodeValue = textValues.synopsis;
  }

}
